import apiConfig from "@/config/apiConfig";
import axios from "axios";
import {ls} from "@/utils/util";

const rootPath = apiConfig.commonApi;
const rootPa = apiConfig.loginApi;
const uploadApi = apiConfig.uploadApi;
const rootregister = apiConfig.companyApi;
const rootPathWeb = apiConfig.financeApi;


/**
 * @description: 弹出计算验证码
 * @return {*}
 */
export const kaptcha = {
    generatekaptcha: rootregister + "/kaptcha/generatekaptcha", // 获取验证码(post)
    verifykaptcha: rootregister + "/kaptcha/verifykaptcha", // 校验验证码(post)
  }
//基地通知
export const basicsBaseCompanyNotice = {
    pageList: rootPath + "/basicsBaseCompanyNotice/pageList", //分页查询
    detail: rootPath + "/basicsBaseCompanyNotice/detail", //新增编辑
    remove: rootPath + "/basicsBaseCompanyNotice/remove/", //批量删除
}


// 热点图
export const companyPointsSystem = {
    getCorporateHeatMap: rootPath + "/companyPointsSystem/getCorporateHeatMap", // 账号密码登录(post)
}

//用户手册下载
export const manageUseManualr = {
    downloadFile: rootregister + "/manageUseManualr/downloadFile", // 账号密码登录(post)
}

//登录模块-后台系统用户登录
export const login_mp = {
    login: rootPa + "/oauth/sc/token", // 账号密码登录(post)
    saveLog: rootPath + "/systemLogApp/saveLog", // 账号密码登录(post)
    logout: rootPa + "/oauth/nuoyun/logout", // 系统后台用户退出登录(post)
}

export const noticeInfoHome = {
    pageList: rootPathWeb+ "/basicsNoticeInfo/pageListRoll"
}

export const basicsEssayInfo = {
    pageList: rootPathWeb+ "/basicsEssayInfo/pageList",
    detail: rootPathWeb + "/basicsEssayInfo/detail",
}

// 登录之后获取滚动消息分页
export const scrollNotice = {
    pageList: rootPath+ "/basicsNoticeInfo/pageListRoll",
    detail: rootPath+ "/basicsNoticeInfo/detail",
}
//注册模块-后台系统用户注册
export const register_mp = {
    register: rootregister + "/portal/userRegister/userRegistration", // 注册用户(post)
    getRoleTreeList: rootregister + "/portal/userRegister/getRoleTreeList", // 用户注册时查询角色下拉列表(get)
    getMechanIsmTreeList: rootregister + "/portal/userRegister/getMechanIsmTreeList", // 用户注册时查询服务机构下拉列表(get)
    getBaseTreeList: rootregister + "/portal/userRegister/getBaseTreeList", // 用户注册时查询基地用户下拉列表(get)
    exportExcelTemplate: rootregister + "/web/webCompanyOriginInfo/exportExcelTemplate", // 用户注册时查询基地用户下拉列表(get)
    verifyUniquePhone: rootregister + "/portal/userRegister/verifyUniquePhone", // 验证用户手机号(get)
    VerifyCompanyName: rootregister + "/portal/userRegister/VerifyCompanyName", // 用户注册时查询基地用户下拉列表(get)
    VerifyCompanyCode: rootregister + "/portal/userRegister/verifyUniqueLicence", // 用户注册时查询基地用户下拉列表(get)
    getPhoneByLicence: rootregister + "/portal/userRegister/getPhoneByLicence", //获取登录以后个人信息
    verifyUniqueIdCard: rootregister + "/portal/userRegister/verifyUniqueIdCard"    // 校验身份证号
}
//系统用户-用户管理
export const sys_admin = {
    changePassword: rootPath + "/systemUser/modifypwd", // 修改密码(post)
    getAdminListData: rootPath + "/systemUser/pageList", // 系统用户列表信息(get)
    getDetail: rootPath + "/systemUser/detail", // 系统用户详细信息(get)
    remove: rootPath + "/systemUser/remove", // 根据主键id删除系统用户(post)
    resetPassword: rootPath + "/systemUser/reset", // 重置密码(post)
    saveupdate: rootPath + "/systemUser/saveOrupdate", // 新增,编辑、启用系统用户信息(post)
    userInfor: rootPath + "/systemUser/info", //获取登录以后个人信息
    getListByRoleId: rootPath + "/systemUser/getListByRole", // 根据用户角色查询用户信息(get)
}
//系统用户-角色管理
export const sys_role = {
    checkRoleName: rootPath + "/systemRole/checkRoleName", // 验证角色名称唯一(post)
    getDetail: rootPath + "/systemRole/detail", // 查看角色详情(get)
    getMenuList: rootPath + "/systemRole/listMenuRoleCheck", // 分配权限时展示菜单信息(get)
    getRoleList: rootPath + "/systemRole/list", // 角色列表信息无分页(get)
    getRoleListData: rootPath + "/systemRole/pageList", // 角色列表信息有分页(get)
    remove: rootPath + "/systemRole/remove", // 删除角色(post)
    setLimit: rootPath + "/systemRole/setLimit", // 分配权限保存信息方法(post)
    saveUpdate: rootPath + "/systemRole/saveOrUpdate", // 新增,编辑、启用角色(post)

}
//系统配置-敏感词设置模块
export const sensitive_words = {
    deleteBatch: rootPath + "/management/sys/sensitiveWords/deleteBatch", // 批量删除敏感词(post)
    getDetail: rootPath + "/sysSensitiveWords/detail", // 根据ID获取敏感词(get)
    getSensitiveWordsListData: rootPath + "/sysSensitiveWords/pageList", // 敏感词列表(get)
    remove: rootPath + "/sysSensitiveWords/remove", // 根据ID删除敏感词(post)
    saveOrUpdate: rootPath + "/sysSensitiveWords/saveOrUpdate", // 保存和更新敏感词(post)
}
//系统配置-字典组模块
export const sys_dict_group_controller = {
    getDetail: rootPath + "/sysDictGroup/detail", // 根据ID获取数据详情(get)
    getDictGroupTreeData: rootPath + "/management/sys/dictGroup/getDictGroupTreeData", // 获取字典组ztree数据(get)
    getPageListData: rootPath + "/sysDictGroup/pageList", // 获取字典组list数据(get)
    remove: rootPath + "/sysDictGroup/remove", // 根据ID删除数据(post)
    saveOrUpdate: rootPath + "/sysDictGroup/saveOrUpdate", // 保存和更新数据(post)
}

//系统配置-字典项模块
export const sys_dict_controller = {
    getDetail: rootPath + "/sysDict/detail", // 根据ID获取数据详情(get)
    getPageListData: rootPath + "/sysDict/pageList", // 获取字典项列表数据(get)
    remove: rootPath + "/sysDict/remove", // 根据ID删除数据(post)
    saveOrUpdate: rootPath + "/sysDict/saveOrUpdate", // 保存和更新数据(post)
}

//系统配置-系统菜单
export const sys_menu = {
    getDetail: rootPath + "/systemMenu/detail", // 系统菜单详情信息(get)
    getMenuListData: rootPath + "/systemMenu/getMenuListData", // 系统菜单列表信息-ztree(get)
    getMethods: rootPath + "/systemMenu/getMethods", // 获取指定菜单下的全部方法(get)
    leftMenuZTree: rootPath + "/systemMenu/leftMenuZTree", // leftMenuZTree(get)
    methodDel: rootPath + "/systemMenu/remove", // 删除方法信息(post)
    methodSaveOrUpdateOrOpen: rootPath + "/systemMenu/methodSaveOrUpdateOrOpen", // 新增、编辑、启动方法信息。当编辑、启动时主键必传(post)
    remove: rootPath + "/systemMenu/remove", // 删除系统菜单信息(post)
    saveOrUpdate: rootPath + "/systemMenu/saveOrUpdate", // 新增、编辑系统菜单信息。当编辑时主键必传(post)
    setMethod: rootPath + "/systemMenu/setMethod", // 一键添加菜单方法(post)
    verifyMenuCode: rootPath + "/systemMenu/verifyMenuCode", // 验证菜单编码唯一(post)
}
//用户管理接口
export const loginUser = {
    getDetail: rootPath + "/management/user/getDetail",
    getPageListData: rootPath + "/management/user/getPageData",
    remove: rootPath + "/management/user/remove",
    edit: rootPath + "/management/user/update",
    add: rootPath + "/management/user/save",
    reset: rootPath + "/management/user/reset",
}

// 飘窗政策通知
export const sys_policyNotice = {
    pageList: rootPathWeb + "/basicsNoticeInfo/pageList",
    detail: rootPathWeb + "/basicsNoticeInfo/detail",
}

// 消息列表
export const sys_messageList = {
    pageList: rootPath + "/enterpriseON/pageList",
    detail: rootPath + "/enterpriseON/detail"
}
// 文件服务接口
export const file_service = {
    upload: uploadApi + "/common/file/upload", // 文件上传
    // upload2: uploadApi + "/common/file/new/upload", // 文件上传
    partUpload: uploadApi + "/common/file/partUpload", // 分片上传
    merge: uploadApi + "/common/file/mergePart", // 合并请求
    download: uploadApi + "/common/file/download/", // 文件下载
    // download2: uploadApi + "/common/file/new/download/", // 文件下载
    delete: uploadApi +"/common/file/delFile/",   //删除文件
    file: (id) => {
        return `${uploadApi}/file/${id}`
    },
    imagesWeb: (id) => {
        return `${uploadApi}/web/commonWeb/file/img?url=${encodeURI(id)}`;
    },
    downloadWeb: (id) => {
        return `${uploadApi}/web/commonWeb/file/download/${encodeURI(id)}`;
    },
    video: (id) => {
        return `${uploadApi}/web/commonWeb/file/video?url=${encodeURI(id)}`;
    },
    images: (id, w, h) => {
        let path = '';
        if (id) {
            path = `${uploadApi}/common/file/download`;
            if (w && h) {
                path += `?w=${w}&h=${h}`
            }
        }
        return path;
    },
    getImgUrl: (file) => {
        axios({
            methods: 'get',
            url: file_service.download + file.uid ,
            // params:{
            //      url:file.uid
            //  },
            responseType: 'blob',
        }).then(res => {
            if(res.headers['content-type'] === 'application/json') {
                file.status = 'error'
                return
            }
            const blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"});
            file.url = window.URL.createObjectURL(blob);
        })
    },
    setImgUrl: (file) => {
        axios({
            methods: 'get',
            url: file_service.download + file.uid ,
            // params:{
            //      url:file.uid
            //  },
            responseType: 'blob',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                Authorization:  'Bearer' + ls.get('token') || ''
            }
        }).then(res => {
            if(res.headers['content-type'] === 'application/json') {
                file.status = 'error'
                return
            }
            const blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"});
            file.url = window.URL.createObjectURL(blob);
        })
    }
}
